module.exports = __webpack_public_path__ + "assets/img/phone.f3cd5134.png";